// src/config.js
const AppConfig = {
    title: "Failed",
    paragraph: "Loading corrupted….",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "failed",
    id: "09120726"
};

export default AppConfig;